import { connectConfigure } from 'instantsearch.js/es/connectors';
import getLocationFromIp from '../../../ipapi';

let didSearchAroundLatLngViaIP = false;
let latLngFromIP = '';

const render = (renderOptions) => {
  const { refine, instantSearchInstance, widgetParams } = renderOptions;
  const state = instantSearchInstance?.helper?.state;
  const currentPresenceValue = state?.hierarchicalFacetsRefinements['presence'][0] || '';

  const shouldSearchAroundLatLngViaIP = () => {
    if (state?.aroundLatLng && state.aroundLatLng !== latLngFromIP) {
      return false;
    }

    if (currentPresenceValue === '' || currentPresenceValue === 'Remote') {
      return false;
    }

    return true;
  };

  const getCorrectLatLng = () => {
    if (shouldSearchAroundLatLngViaIP()) {
      return latLngFromIP;
    }

    return state?.aroundLatLng === latLngFromIP ? '' : state?.aroundLatLng;
  };

  if (didSearchAroundLatLngViaIP !== shouldSearchAroundLatLngViaIP()) {
    didSearchAroundLatLngViaIP = shouldSearchAroundLatLngViaIP();

    refine({
      ...widgetParams.searchParameters,
      aroundLatLng: getCorrectLatLng(),
    });
  }
};

const connectedConfigure = connectConfigure(render);

const setupEvents = () => {
  document.addEventListener('ipapi:success', ({ detail }) => {
    latLngFromIP = detail.aroundLatLng;
  });
};

export const configure = (options) => {
  setupEvents();
  getLocationFromIp();

  return connectedConfigure({
    searchParameters: {
      ...options,
    },
  });
};
